import { render } from "./IconMinusCircle.vue?vue&type=template&id=47388c0a"
import script from "./IconMinusCircle.vue?vue&type=script&lang=js"
export * from "./IconMinusCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__